export const HASHTAG_REGEX = /^#?([^\s/@?#]+)$/;
export const PROFILE_TAG_REGEX = /^@?([^\s/@?#]+)$/;
export const URL_REGEX =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)\b/;
export const DECODED_HASHTAG_REGEX =
  /#([\w\p{L}\p{M}\u0430-\u044f]|(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]|[\u10a0-\u10ff])?)+/giu;
